import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card, CardContent } from '../components/ui/Card';
import { GraduationCap, Building2, School } from 'lucide-react';
export function LoginPage() {
  const [userType, setUserType] = useState<'student' | 'landlord' | 'university'>('student');
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(`/dashboard/${userType}`);
  };
  return <div className="min-h-screen bg-slate-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-809" data-mp="g7ntozq3b9u7">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-810" data-mp="b8jlocewji5g">
        <Link to="/" className="flex justify-center items-center gap-2 mb-6" data-id="element-811" data-mp="ba4enxlkit17">
          <img src="https://cdn.magicpatterns.com/uploads/37CjFFhCaYFTTZ1oinSNtZ/Cam_main_ver_logo.png" alt="CampusAparte" className="h-12 w-auto" data-id="element-812" data-mp="68f0i931tz8w" />
        </Link>
        <h2 className="text-center text-3xl font-bold tracking-tight text-brand-dark" data-id="element-813" data-mp="1ur2efdt8u8dy">
          Sign in to your account
        </h2>
        <p className="mt-2 text-center text-sm text-slate-600" data-id="element-814" data-mp="1zkncf5uu72d5">
          Or{' '}
          <Link to="/signup" className="font-medium text-brand-primary hover:text-brand-light" data-id="element-815" data-mp="1kvhjfzmle8dp">
            create a new account
          </Link>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-816" data-mp="2dj3icukvkou8">
        <Card data-id="element-817" data-mp="2igdip59sykwu">
          <CardContent className="p-8" data-id="element-818" data-mp="2ig3of5hq5rlc">
            {/* User Type Selector */}
            <div className="grid grid-cols-3 gap-2 mb-8 p-1 bg-slate-100 rounded-lg" data-id="element-819" data-mp="23kxn2vtkqgyc">
              {[{
              id: 'student',
              icon: GraduationCap,
              label: 'Student'
            }, {
              id: 'landlord',
              icon: Building2,
              label: 'Landlord'
            }, {
              id: 'university',
              icon: School,
              label: 'Admin'
            }].map(type => <button key={type.id} onClick={() => setUserType(type.id as any)} className={`flex flex-col items-center justify-center py-2 rounded-md text-xs font-medium transition-all ${userType === type.id ? 'bg-white text-brand-dark shadow-sm ring-1 ring-slate-200' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-820" data-mp="2q0xuatw3vjaw">
                  <type.icon className={`w-5 h-5 mb-1 ${userType === type.id ? 'text-brand-primary' : ''}`} data-id="element-821" data-mp="2c3j2xjmal1ga" />
                  {type.label}
                </button>)}
            </div>

            <form className="space-y-6" onSubmit={handleLogin} data-id="element-822" data-mp="5ayreytx40f5">
              <Input label="Email address" type="email" placeholder={userType === 'university' ? 'admin@university.edu.ng' : 'you@example.com'} required data-id="element-823" data-mp="58cjuz711kwx" />

              <div data-id="element-824" data-mp="hky8ibyboe22">
                <Input label="Password" type="password" required data-id="element-825" data-mp="hkodub2c1iq1" />
                <div className="flex justify-end mt-1" data-id="element-826" data-mp="hnanqhcp4abf">
                  <a href="#" className="text-sm font-medium text-brand-primary hover:text-brand-light" data-id="element-827" data-mp="mipyh0fepq3m">
                    Forgot password?
                  </a>
                </div>
              </div>

              <Button type="submit" className="w-full" data-id="element-828" data-mp="3uzba6ozfaxaf">
                Sign in as{' '}
                {userType.charAt(0).toUpperCase() + userType.slice(1)}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>;
}